import React, { useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import utils from '@gjensidige/core-utilities-css';
import { PrimaryButton, SecondaryButton } from '@gjensidige/nci-core-buttons';
import { Link, Text, Title } from '@gjensidige/nci-core-typography';

import styles from '../assets/styles/shared.module.scss';
interface Props {
  adUrl?: string;
}
export const Login: React.FC<Props> = ({ adUrl }) => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const referer = urlParams.get('referer');

  const paramString = referer ? `?referer=${referer}` : '';
  const [loading, setLoading] = useState(false);

  return (
    <div className={styles.overrides}>
      <div
        className={classNames(
          styles.mainLogin,
          utils['mt-2'],
          utils['ml-md-4']
        )}
      >
        <Title size="h3" tag="h1">
          Log in
        </Title>
        <Text size="p">
          Some pages are only for Gjensidige employees and partners. Please log
          in with your Gjensidige account or guest credentials. If you have
          issues with your access,{' '}
          <Link href="https://www.gjensidige.builders/links/social/slack-builders-community">
            reach out to Team Builders.
          </Link>
        </Text>
        <div className={utils['mt-2']}>
          <PrimaryButton
            color="blue"
            onClick={() => setLoading(true)}
            loading={loading}
            href={`${adUrl}/${referer ? referer : ''}`}
            className={classNames(utils['mr-1'], utils['mt-1'])}
          >
            Gjensidige access
          </PrimaryButton>
          <SecondaryButton
            className={utils['mt-1']}
            onClick={(event: React.SyntheticEvent<HTMLButtonElement>) => {
              event.preventDefault();
              history.push(`/guests${paramString}`);
            }}
          >
            Guest access
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
};
